// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"04522865","166":"a6b48f70","258":"efd0dda0","331":"8840ceb6","342":"7afa8f3c","350":"cd3d0b2a","428":"536015aa","452":"138a0f45","490":"aea21e7b","756":"7a7d3921","777":"d1a9536f","807":"38402499","906":"6f678273","936":"b541ee8f"}[chunkId] + ".chunk.js";
};